import { useEffect } from 'react';
import { clearTokenCache } from '../services/ProxyApi';

// The key we'll use in localStorage to communicate logout events
const LOGOUT_KEY = 'app_logout_event';

/**
 * Function to broadcast logout to all tabs
 */
export const broadcastLogout = () => {
  // Set the logout key with the current timestamp
  localStorage.setItem(LOGOUT_KEY, Date.now().toString());
  console.log('Broadcasting logout to other tabs');
};

/**
 * Function to handle logout in the current tab
 * This doesn't use navigation so it can be called from anywhere
 */
export const handleLogoutEvent = () => {
  // Clear any client-side caches
  clearTokenCache();
  console.log('Logout handled in current tab');
};

/**
 * Custom hook that listens for logout events from other tabs
 * No longer requires Router context since we're just refreshing the page
 */
export const useLogoutListener = () => {
  useEffect(() => {
    // Handler for storage events (triggered when localStorage changes in other tabs)
    const handleStorageChange = (event) => {
      // Only respond to our specific logout key
      if (event.key === LOGOUT_KEY && event.newValue) {
        console.log('Logout event detected in another tab, refreshing page');
        // Clear token cache first
        handleLogoutEvent();
        // Then refresh the page - this will cause AuthGuard to redirect to login
        window.location.reload();
      }
    };

    // Add event listener for storage events
    window.addEventListener('storage', handleStorageChange);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};